import axios from 'axios';
import {REQUEST_URL} from '../config/urls';

const requisitar = () => {
  return {
    type: "REQUISITAR_PRODUTO"
  };
}

const obterTodos = (produtos) => {
  return {
    type: "OBTER_TODOS_PRODUTOS",
    produtos
  }
}

const novoProduto = (produto) => {
  return {
    type: "NOVO_PRODUTO",
    produto
  }
}

const alterarProduto = (produto) => {
  return {
    type: "ALTERAR_PRODUTO",
    produto
  }
}

const removerProduto = (id) => {
  return {
    type: "REMOVER_PRODUTO",
    id
  }
}
const erro = (erro) => {
  if (erro.response.data.error.statusCode === 401) {
    axios.defaults.headers.common['Authorization'] = "";
    return {
      type: "LOGOUT"
    }
  }
  return {
    type: "ERRO_PRODUTO",
    erro
  }
}
export const adicionarProduto = (produto) => {
  return dispatch => {
    dispatch(requisitar());
    return axios.post(`${REQUEST_URL}/produtos`, produto).then((response) => {
      dispatch(novoProduto(response.data));
    }).catch(error => {
      dispatch(erro(error.response.data.error));
    });
  }
}

export const editarProduto = (produto, id) => {
  return dispatch => {
    dispatch(requisitar());
    return axios.patch(`${REQUEST_URL}/produtos/${id}`, produto).then((response) => {
      dispatch(alterarProduto(response.data));
    }).catch(error => {
      dispatch(erro(error.response.data.error));
    });
  }
}

export const deletarProduto = (id) => {
  return dispatch => {
    dispatch(requisitar());
    return axios.delete(`${REQUEST_URL}/produtos/${id}`).then(() => {
      dispatch(removerProduto(id));
    }).catch(error => {
      dispatch(erro(error.response.data.error));
    });
  }
}

export const obterProdutos = () => {
  return dispatch => {
    dispatch(requisitar());
    return axios.get(`${REQUEST_URL}/produtos`).then((response) => {
      dispatch(obterTodos(response.data));
    }).catch(error => {
      dispatch(erro(error.response.data.error));
    });
  }
}



// WEBPACK FOOTER //
// ./src/actions/ProdutoActions.js